/* (c) Quick Pro USA (quickprousa.com) - proprietary theme code. All rights reserved. */
/* qp-rime-intro.js — one-shot reveal for sections/qp-rime-intro.liquid
   (spec 2026-10-05 §2 Motion). Adds `is-ready` only when IntersectionObserver
   exists, reduced motion is off and we are not in the theme editor; all hidden
   initial states live under `.is-ready` in the CSS, so no-JS renders final.
   On first intersection adds `is-in` and unobserves. Idempotent per node;
   re-runs on shopify:section:load. No dependencies. */
(function (win) {
  'use strict';
  var doc = win.document;

  function canAnimate() {
    if (!('IntersectionObserver' in win)) return false;
    if (win.Shopify && win.Shopify.designMode) return false;
    return !(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function init(scope) {
    if (!scope || !scope.querySelectorAll || !canAnimate()) return;
    var nodes = Array.prototype.slice.call(scope.querySelectorAll('[data-qp-rime-intro].qp-rime-intro--reveal'));
    if (scope.matches && scope.matches('[data-qp-rime-intro].qp-rime-intro--reveal')) nodes.unshift(scope);
    nodes.forEach(function (el) {
      if (el.__qpRimeIntro) return;
      el.__qpRimeIntro = true;
      el.classList.add('is-ready');
      var io = new win.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.25, rootMargin: '0px 0px -10% 0px' });
      io.observe(el);
    });
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  } else {
    init(doc);
  }
  if (!doc.__qpRimeIntroBound) {
    doc.__qpRimeIntroBound = true;
    doc.addEventListener('shopify:section:load', function (e) { init(e.target || doc); });
  }
})(window);
